module.exports = __webpack_public_path__ + "img/Vector_50_9557.4699b3c8.png";